/**
 * Rows of the admin's Users table (ux-admin-05): one per account from
 * `getAdminUsersInsights` (every `users` doc), joined by uid with its token
 * stats from `getAdminUserStats` (only accounts that already used AI). A
 * person stuck before their first AI call is a row without stats ("No AI
 * usage"), not a missing row. Token stats without an account (deleted
 * accounts) are appended after.
 */
/** Accounts first (insights, the base), then stats without an account. Null lists count as not loaded. */
export function joinAdminUserRows(stats, insights) {
    const statByUid = new Map((stats ?? []).map((s) => [s.uid, s]));
    const rows = [];
    const seen = new Set();
    for (const insight of insights ?? []) {
        if (seen.has(insight.uid))
            continue;
        seen.add(insight.uid);
        rows.push({ uid: insight.uid, stat: statByUid.get(insight.uid) ?? null, insight });
    }
    for (const stat of stats ?? []) {
        if (seen.has(stat.uid))
            continue;
        seen.add(stat.uid);
        rows.push({ uid: stat.uid, stat, insight: null });
    }
    return rows;
}
export function adminUserRowName(row) {
    return row.insight?.displayName ?? row.stat?.displayName ?? row.uid;
}
/**
 * The filter that can apply: «No AI usage» needs the token stats and «Stuck»
 * the insights. Without its list a filter would claim something nobody knows
 * (every row "without AI usage" because the stats failed), so it falls back
 * to "all" and the admin disables that option.
 */
export function effectiveAdminUserFilter(filter, loaded) {
    if (filter === "no_ai_usage" && !loaded.stats)
        return "all";
    if (filter === "stuck" && !loaded.insights)
        return "all";
    return filter;
}
/** Does the row match the search (name, email or uid prefix, case-insensitive) and the filter that can apply? */
export function matchesAdminUserRow(row, query, filter, loaded) {
    const applied = effectiveAdminUserFilter(filter, loaded);
    if (applied === "stuck" && !row.insight?.stuckInOnboarding)
        return false;
    if (applied === "no_ai_usage" && row.stat)
        return false;
    const q = query.trim().toLowerCase();
    if (!q)
        return true;
    return (adminUserRowName(row).toLowerCase().includes(q) ||
        (row.insight?.email ?? "").toLowerCase().includes(q) ||
        row.uid.toLowerCase().startsWith(q));
}
//# sourceMappingURL=admin-user-rows.js.map